<script>
  import AddList from "../form/AddList.svelte";
  import Validators from "../../utils/validators";
  import { countries, languages, dma } from "../../assets/GeoData";
  import { days } from "../../assets/commonData";
  import { onMount } from "svelte";

  export let data = {};

   let formData = {
    deviceData: [],
    geoData: [],
    partingData: [],
    coordinateData: [],
    frequencyData: [],
    segmentPeriodData: [],
    segmentData: [],
  };

  let fields = {
    deviceFields: [
      {
        type: "list",
        name: "type",
        items: [
          { value: "CTV", label: "CTV" },
          { value: "OOH", label: "OOH" },
          { value: "Hybrid", label: "Hybrid" },
        ],
        isCheckable: false,
        label: "Type",
        placeholder: "Select device type(s)",
        readonlyValue: true,
        validations: [Validators.required("Device is required")],
      },
    ],
    geoFields: [
      {
        type: "list",
        name: "country",
        label: "Country",
        items: countries,
        readonlyValue: true,
        validations: [Validators.required("Country is required")],
      },
      {
        type: "list",
        name: "dma",
        items: dma,
        label: "DMA",
        readonlyValue: true,
        validations: [Validators.required("DMA is required")],
      },
      {
        type: "number",
        name: "zipcode",
        label: "Zipcode",
        readonlyValue: true,
        validations: [Validators.required("Zipcode is required")],
      },
    ],
    partingFields: [
      {
        type: "list",
        name: "day",
        items: days,
        label: "Day",
        readonlyValue: true,
        validations: [Validators.required("Day is required")],
      },
      {
        type: "time",
        name: "start",
        inputClass:"w-8 !px-1",
        readonlyValue: true,
        label: "Start At",
      },
      {
        type: "time",
        name: "end",
        inputClass:"w-8 !px-1",
        readonlyValue: true,
        label: "End At",
      },
    ],
    coordinateFields: [
      {
        type: "number",
        name: "coordinates",
        label: "Longitude / Latitude",
        readonlyValue: true,
      },
      {
        type: "number",
        name: "radius",
        label: "Radius",
        readonlyValue: true,
      },
    ],
    frequencyFields: [
      {
        type: "number",
        name: "limit",
        label: "Number Of Times",
        placeholder: "Select a number",
        readonlyValue: true,
      },
      {
        type: "time",
        name: "time",
        label: "Time Period",
        placeholder: "Select a time period",
        inputClass:"w-8 !px-1",
        readonlyValue: true,
      },
    ],
    
  };

  onMount(() => {
    if (data && Object.keys(data).length !== 0) {
      formData.deviceData = data.device;
      formData.geoData = data.geo;
      formData.partingData = data.parting;
      formData.coordinateData = data.coordinates;
      formData.frequencyData = data.frequency_capping;
      formData.segmentPeriodData = data.segment_period;
      formData.segmentData = data.segments;
    }
  });

  function onAddRow(dataKey, dataObj) {
    formData[dataKey] = [...formData[dataKey], dataObj];
  }

  function onDeleteRow(dataKey, index) {
    // console.log(dataKey, index);

    formData[dataKey] = formData[dataKey].filter((_, i) => i !== index);

    // console.log(formData);
  }
</script>

<h1 class="pb-2 text-xl font-bold">Device</h1>
<div class="flex flex-row w-1/2 gap-2 pb-4">
  <AddList
    name="targeting_device"
    fields={fields.deviceFields}
    data={formData.deviceData}
    onAddRow={(data) => onAddRow("deviceData", data)}
    onDeleteRow={(index) => onDeleteRow("deviceData", index)} />
</div>

<h1 class="pb-2 text-xl font-bold">Geo</h1>
<div class="flex flex-row w-full gap-2 pb-4">
  <AddList
    name="targeting_geo"
    fields={fields.geoFields}
    data={formData.geoData}
    onAddRow={(data) => onAddRow("geoData", data)}
    onDeleteRow={(index) => onDeleteRow("geoData", index)} />
</div>

<div class="flex flex-row w-full gap-2 pb-4">
  <div class="w-1/2">
    <h1 class="pb-2 text-xl font-bold">Day Parting</h1>
    <AddList
      name="targeting_parting"
      fields={fields.partingFields}
      data={formData.partingData}
      onAddRow={(data) => onAddRow("partingData", data)}
      onDeleteRow={(index) => onDeleteRow("partingData", index)} />
  </div>
  <div class="w-1/2">
    <h1 class="pb-2 text-xl font-bold">Longitude / Latitude</h1>
    <AddList
      name="targeting_coordinates"
      fields={fields.coordinateFields}
      data={formData.coordinateData}
      onAddRow={(data) => onAddRow("coordinateData", data)}
      onDeleteRow={(index) => onDeleteRow("coordinateData", index)} />
  </div>
</div>
<div class="flex flex-row w-full gap-2 pb-4">
  <div class="w-1/2">
    <h1 class="pb-2 text-xl font-bold">Frequency Capping</h1>
    <AddList
      name="frequency_capping"
      fields={fields.frequencyFields}
      data={formData.frequencyData}
      onAddRow={(data) => onAddRow("frequencyData", data)}
      onDeleteRow={(index) => onDeleteRow("frequencyData", index)} />
  </div>
</div>

